/**
 * 订单转派页 — 本地 reducer
 *
 * 【职责】
 * - 维护订单头（orderId / orderNo）、转派物料表、表格多选 key
 * - 转派目标供应商由页面 Form 管理；路由/详情首次进入不预填；Redux 页缓存可还原用户已选供应商
 * - 与 hooks 中「Redux 全页缓存」序列化的对象结构保持一致（勿随意改字段名）
 */
import type { Key } from 'react'
import { ActionType, CustomAction } from '../../global'

/** 转派物料表格单行（由订单详情行 normalize 而来） */
export type TransferMaterialRow = {
  id: string
  code: string
  platformMaterialCode?: string
  systemCategoryCode?: string
  brand?: string
  name?: string
  model?: string
  /** 订单行数量（与详情接口 num 一致，用于计算可转派数量） */
  num?: number
  /** 取消数量 cancelCount */
  cancelCount?: number
  /** 退货数量 reCount */
  reCount?: number
  /**
   * 可转派数量 = num − cancelCount − reCount（与订单详情、转派校验口径一致）
   * 写入缓存时一并带上 num 三字段，恢复页后可重算
   */
  transferableQty: number
  unit?: string
}

/** 整页可缓存状态快照 */
export interface OrderTransferState {
  orderId: string
  orderNo: string
  materialList: TransferMaterialRow[]
  /** 表格 rowSelection 选中行的 rowKey（与 materialList[].id 对应） */
  selectedMaterialRowKeys: Key[]
  type: string
}

export const initialState: OrderTransferState = {
  type: '',
  orderId: '',
  orderNo: '',
  materialList: [],
  selectedMaterialRowKeys: [],
}

type Action = ActionType<OrderTransferState>

const reducer = (
  state: OrderTransferState = initialState,
  action: CustomAction<Action>,
): OrderTransferState => {
  const newstate = { ...state }
  switch (action.type) {
    case 'setOrderIdAction':
      newstate.orderId = action.payload
      return newstate
    case 'setOrderNoAction':
      newstate.orderNo = action.payload
      return newstate
    case 'setMaterialListAction':
      newstate.materialList = action.payload
      return newstate
    case 'setSelectedMaterialRowKeysAction':
      newstate.selectedMaterialRowKeys = action.payload
      return newstate
    /** 从缓存或路由一次性恢复整页（替换整个 state） */
    case 'reloadStateAction':
      return { ...action.payload }
    case 'resetStateAction':
      return initialState
    default:
      return state
  }
}

export default reducer

// ---------- Action creators（命名与项目 global ActionType 约定一致） ----------

export const setOrderIdAction = (param: string): CustomAction<Action> => ({
  type: 'setOrderIdAction',
  payload: param,
})

export const setOrderNoAction = (param: string): CustomAction<Action> => ({
  type: 'setOrderNoAction',
  payload: param,
})

export const setMaterialListAction = (
  param: TransferMaterialRow[],
): CustomAction<Action> => ({
  type: 'setMaterialListAction',
  payload: param,
})

export const setSelectedMaterialRowKeysAction = (
  param: Key[],
): CustomAction<Action> => ({
  type: 'setSelectedMaterialRowKeysAction',
  payload: param,
})

export const reloadStateAction = (
  param: OrderTransferState,
): CustomAction<Action> => ({
  type: 'reloadStateAction',
  payload: param,
})

export const resetStateAction = (): CustomAction<Action> => ({
  type: 'resetStateAction',
  payload: undefined,
})
/**
 * 订单转派页 — 本地 reducer
 *
 * 【职责】
 * - 维护订单头（orderId / orderNo）、转派物料表、表格多选 key
 * - 转派目标供应商由页面 Form 管理；路由/详情首次进入不预填；Redux 页缓存可还原用户已选供应商
 * - 与 hooks 中「Redux 全页缓存」序列化的对象结构保持一致（勿随意改字段名）
 */
import type { Key } from 'react'
import { ActionType, CustomAction } from '../../global'

/** 转派物料表格单行（由订单详情行 normalize 而来） */
export type TransferMaterialRow = {
  id: string
  code: string
  platformMaterialCode?: string
  systemCategoryCode?: string
  brand?: string
  name?: string
  model?: string
  /** 订单行数量（与详情接口 num 一致，用于计算可转派数量） */
  num?: number
  /** 取消数量 cancelCount */
  cancelCount?: number
  /** 退货数量 reCount */
  reCount?: number
  /**
   * 可转派数量 = num − cancelCount − reCount（与订单详情、转派校验口径一致）
   * 写入缓存时一并带上 num 三字段，恢复页后可重算
   */
  transferableQty: number
  unit?: string
}

/** 整页可缓存状态快照 */
export interface OrderTransferState {
  orderId: string
  orderNo: string
  materialList: TransferMaterialRow[]
  /** 表格 rowSelection 选中行的 rowKey（与 materialList[].id 对应） */
  selectedMaterialRowKeys: Key[]
  type: string
}

export const initialState: OrderTransferState = {
  type: '',
  orderId: '',
  orderNo: '',
  materialList: [],
  selectedMaterialRowKeys: [],
}

type Action = ActionType<OrderTransferState>

const reducer = (
  state: OrderTransferState = initialState,
  action: CustomAction<Action>,
): OrderTransferState => {
  const newstate = { ...state }
  switch (action.type) {
    case 'setOrderIdAction':
      newstate.orderId = action.payload
      return newstate
    case 'setOrderNoAction':
      newstate.orderNo = action.payload
      return newstate
    case 'setMaterialListAction':
      newstate.materialList = action.payload
      return newstate
    case 'setSelectedMaterialRowKeysAction':
      newstate.selectedMaterialRowKeys = action.payload
      return newstate
    /** 从缓存或路由一次性恢复整页（替换整个 state） */
    case 'reloadStateAction':
      return { ...action.payload }
    case 'resetStateAction':
      return initialState
    default:
      return state
  }
}

export default reducer

// ---------- Action creators（命名与项目 global ActionType 约定一致） ----------

export const setOrderIdAction = (param: string): CustomAction<Action> => ({
  type: 'setOrderIdAction',
  payload: param,
})

export const setOrderNoAction = (param: string): CustomAction<Action> => ({
  type: 'setOrderNoAction',
  payload: param,
})

export const setMaterialListAction = (
  param: TransferMaterialRow[],
): CustomAction<Action> => ({
  type: 'setMaterialListAction',
  payload: param,
})

export const setSelectedMaterialRowKeysAction = (
  param: Key[],
): CustomAction<Action> => ({
  type: 'setSelectedMaterialRowKeysAction',
  payload: param,
})

export const reloadStateAction = (
  param: OrderTransferState,
): CustomAction<Action> => ({
  type: 'reloadStateAction',
  payload: param,
})

export const resetStateAction = (): CustomAction<Action> => ({
  type: 'resetStateAction',
  payload: undefined,
})
